import React, { useState, useEffect } from "react";
import axios from "axios";
import Entete from '../layout/EnteteSimple'
import * as XLSX from "xlsx";
import apiLink from "../../config";
import { Navigate } from 'react-router-dom';

function CreationExploit() {
    const role = JSON.parse(localStorage.getItem('role'));

    const [assol_Exploitant, setassol_Exploitant] = useState(null);
    const [dataDefaut, setDataDefaut] = useState()
    const [idExploitationParAgent, setidExploitationParAgent] = useState({})
    const cepageList = {"1":{"key":"none","surface":"0.00","rendement":90.3,"prix":173}}
    const mesDonnees = new FormData(); 
    const mesDonneesP = new FormData(); 

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const reader = new FileReader();
        reader.onload = (event) => {
        const data = new Uint8Array(event.target.result);
        const workbook = XLSX.read(data, { type: "array" });

        // On prend la première feuille
        const firstSheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[firstSheetName];

        // On convertit en JSON
        const jsonData = XLSX.utils.sheet_to_json(worksheet);
        setassol_Exploitant(jsonData); // ← Voilà ta constante "assol_Exploitant"
        
        };
        reader.readAsArrayBuffer(file);
    };

    function conversionData(DDef) {
        const Productions = {};

        Object.keys(DDef).forEach((key) => {
            const item = DDef[key];
            const libelle = item.libelle;

            const specs = item.specifications;
            const new_specs = {};

            Object.keys(specs).forEach((skey) => {
                const s = specs[skey];
                new_specs[skey] = {
                    libelle: libelle,
                    SelectedSpe: skey,
                    surface: "0.00",
                    rendement: s.rendement,
                    prix: s.prix,
                    typeCulture: "Conventionnelle",
                    Semis: "",
                };
            });

            new_specs["none"] = {
                libelle: libelle,
                SelectedSpe: "none",
                surface: "0.00",
                rendement: item.rendement,  
                prix: item.prix !== null && item.prix !== undefined ? item.prix : 120,
                typeCulture: "Conventionnelle",
                Semis: "",
            };


            Productions[key] = new_specs;
        });

        return Productions;
    }

    function ajoutSurf(Productions, item) {
        Object.keys(item).forEach(key => {
            if (Productions.hasOwnProperty(key)) {
                const prod = Productions[key];
                const surface = item[key];
                const prixKey = "Prix_" + key;
                const rdtKey = "Rdt_" + key; // au cas où tu as un jour rendement

                if (prod["none"]) {
                    prod["none"].surface = surface.toString();

                    if (item.hasOwnProperty(prixKey)) {
                        prod["none"].prix = item[prixKey];
                    }

                    if (item.hasOwnProperty(rdtKey)) {
                        prod["none"].rendement = item[rdtKey];
                    }
                }
            }
        });

        return Productions; // si tu veux l'utiliser en chaîne
    }



    function creaExploit(data){
        //fetch(apiLink + 'getExploitationDefault/' + data.idCommune)
        const token = localStorage.getItem('token');
        fetch(apiLink + 'getExploitationDefault', {
            method: 'POST',
            headers: {
                'content-type': 'application/json',
                'Authorization': 'Bearer ' + token
            },
            body: JSON.stringify({
                idCommune: data.idCommune
            })
        })
        .then( response => {
            return response.json()
        })
        .then((response) => {
            setDataDefaut(response)
            const Productions = conversionData(response)
            const ProductionsFinales = ajoutSurf(Productions, data)

            var prod = JSON.stringify(ProductionsFinales)
            mesDonnees.set("productions", prod);
            mesDonnees.set("nom", "Principale");
            mesDonnees.set("idCommune", data.idCommune);

            const token = localStorage.getItem('token');
            axios({
                method: 'post',
                url: apiLink + 'setExploitation',
                data: mesDonnees,
                headers: {
                'Authorization': 'Bearer ' + token
                }
            })
            .then(function (reponse) {
                if(reponse.status === 200){
                    var idExploitationCree = reponse.data.idExploitation
                    setidExploitationParAgent(prev => ({ //ajout des élément pour faire la liste que lon colle dans l'excel
                        ...prev,
                        [data.idAgent]: idExploitationCree
                    }));
                    mesDonnees.set("productions", prod);
                    mesDonnees.set("nom", "Principale");
                    mesDonnees.set("idCommune", data.idCommune);
                    mesDonneesP.set("IdExploitation", idExploitationCree);
                    var cepageListFinale = JSON.stringify(cepageList)
                    var JSON_P = {"productions" : prod, "nom": "Principale", "idCommune": data.idCommune, "idExploitation":idExploitationCree,"cepage": cepageListFinale}
                    
                    //Kani a modifier ici 
                    const token = localStorage.getItem('token');
                    const jsonData = JSON.stringify(JSON_P);
                    axios.post('https://api2050.diagorisk.com/newSimul/', 
                        jsonData, 
                        {
                        headers: {
                            'content-type': 'application/json',
                            'Authorization': 'Bearer ' + token
                        }
                    })
                    .catch(error => {
                        console.error('Error:', error);
                    });
                } 
                else {
                    alert("Une erreur c'est produite, votre assolement n'a pas pû être enregistré")
                }
            })
        })
        
    }

    useEffect(() => {
        if (assol_Exploitant) {
        assol_Exploitant.forEach(item => {
            creaExploit(item); // appelé une fois par item
        });
        }
    }, [assol_Exploitant]); 


    if (role !== 'ROLE_ADMINISTRATEUR') {
        return <Navigate to="*" replace />;
    }

    return (
        <div>
            <Entete titre="Creation groupe exploit" />
            <div className='container'>
                <h2>Importer le fichier d'assolement cf modèle</h2>
                <input type="file" accept=".xlsx,.xls" onChange={handleFileChange} />
                <pre>{assol_Exploitant ? "✅ Fichier importé avec succès": "Aucun fichier importé"}</pre>
                <pre>{assol_Exploitant ? JSON.stringify(assol_Exploitant, null, 2) : "Aucun fichier importé"}</pre>

                <h2> {JSON.stringify(idExploitationParAgent, null, 2)}</h2>

                {/*assol_Exploitant && assol_Exploitant.map((item, index) => (
                    <div key={index}>
                        {item.idCommune}
                        {creaExploit(item)} 
                    </div>
                ))*/}


            </div>
        </div>
    )
}

export default CreationExploit